import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.dialogTarget.showModal()
  }

  preventClose(event) {
    event.preventDefault()
  }

  acknowledge() {
    // Body scroll will be restored automatically when dialog is removed from DOM
  }
}
